import React from 'react';

import DeleteOutlineRoundedIcon from '@material-ui/icons/DeleteOutlineRounded';
import { StyledIconButton } from 'styles/common';

import { DeleteContainer } from './styles';

export default function DeleteComponent({ deleteImage }) {
  return (
    <DeleteContainer className="deleteContainer">
      <StyledIconButton onClick={deleteImage}>
        <DeleteOutlineRoundedIcon />
      </StyledIconButton>
    </DeleteContainer>
  );
}
